import React from "react";

const Heading = ({ heading, color = "black" }) => {
  return <div className={`text-3xl font-body3 font-medium text-${color} text-center pb-6`}>{heading}</div>;
};

export default Heading;
